import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Box,
  Text,
  RadioGroup,
  Stack,
  Radio,
  Spinner,
  Collapse,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
  Checkbox,
  CheckboxGroup,
  Select
} from "@chakra-ui/react";

const TargetSelectionModal = ({
  isOpen,
  onClose,
  columns,
  selectedTarget,
  setSelectedTarget,
  predictionMessage,
  isPredictLoading,
  predictionResults,
  predictionOpen,
  selectedSourceVariables,
  setSelectedSourceVariables,
  rePrediction
}) => {
  // State to toggle the collapsible sections
  const [showDefinitions, setShowDefinitions] = React.useState(false);
  const [showModelDescription, setShowModelDescription] = React.useState(false);
  const [userSource, setUserSources] = React.useState(null)
  const [userTarget, setUserTarget] = React.useState(null)

  React.useEffect(()=>{
    if(userTarget){
        console.log(`----> ${userTarget}`)
        rePrediction()
    }
  },[userSource])

  // Debug: log columns and selectedTarget for debugging
  React.useEffect(() => {
    console.log("Columns:", columns);
    console.log("Selected target:", selectedTarget);
  }, [columns, selectedTarget]);

  // Set all source variables selected by default when columns or target changes,
  // excluding the "year" column and the currently selected target.
  React.useEffect(() => {
    if (columns && columns.length > 0) {
      const normalizedTarget = selectedTarget ? selectedTarget.toLowerCase() : "";
      const defaultSources = columns
        .filter(
          (col) =>
            col.key.toLowerCase() !== normalizedTarget &&
            col.key.toLowerCase() !== "year"
        )
        .map((col) => col.key);
      console.log("Default sources:", defaultSources);
      setSelectedSourceVariables(defaultSources);
    }
  }, [columns, selectedTarget, setSelectedSourceVariables]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>เปรียบเทียบประสิทธิภาพ Model ประเภทต่างๆ</ModalHeader>
        <ModalBody>
          <Flex
            direction="row"
            gap={4}
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Flex direction={"column"} flex="1">
              <Box flex="1">
                <Text mb={4}>กรุณาเลือก target variable:</Text>
                <Select
  placeholder="เลือก target variable"
  onChange={e => {
    setUserTarget(e.target.value);
    setSelectedTarget(e.target.value);
  }}
  value={selectedTarget}
>
  {columns
    .filter(col =>
      col.key.toLowerCase() !== "year" &&
      !col.key.toLowerCase().includes("ปี")
    )
    .map(col => (
      <option key={col.key} value={col.key}>
        {col.name}
      </option>
    ))
  }
</Select>

                {selectedTarget && (
                  <Box
                    mt={4}
                    fontSize="sm"
                    color="gray.600"
                    dangerouslySetInnerHTML={{ __html: predictionMessage() }}
                  />
                )}
              </Box>
              <Box mt={4}>
                <Text mb={2}>
                  เลือกตัวแปรต้น (Source Variables) ที่ต้องการใช้:
                </Text>
                <CheckboxGroup
                  value={selectedSourceVariables}
                  onChange={(values) => {
                    setSelectedSourceVariables(values)
                    setUserSources(values)
                }}
                >
                  <Stack direction="column">
                    {columns
                      .filter(
                        (col) =>
                          col.key.toLowerCase() !==
                            (selectedTarget
                              ? selectedTarget.toLowerCase()
                              : "") &&
                          col.key.toLowerCase() !== "year"
                      )
                      .map((col) => (
                        <Checkbox key={col.key} value={col.key}>
                          {col.name}
                        </Checkbox>
                      ))}
                  </Stack>
                </CheckboxGroup>
              </Box>
            </Flex>

            <Flex direction="row" gap={4}>
              {/* Right Column: Prediction Results or Spinner */}
              {selectedTarget && <Flex
                direction={"column"}
                flex="1"
                borderWidth="1px"
                borderColor="gray.800"
                borderRadius="md"
                p={4}
                boxShadow="md"
                justify={"top"}
                align={"top"}
              >
                {isPredictLoading ? (
                  <Flex justify="center" align="center" h="100%">
                    <Spinner size="xl" />
                  </Flex>
                ) : (
                  predictionResults &&
                  predictionResults.Model && (
                    <>
                      <Flex
                        justify="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <Text fontWeight="bold">
                          ผลการเปรียบเทียบ Error ของ Model สำหรับ{" "}
                          {selectedTarget}
                        </Text>
                      </Flex>
                      <Collapse in={predictionOpen}>
                        {(() => {
                          const sortedResults = predictionResults.Model.map(
                            (model, index) => ({
                              model,
                              rmse: predictionResults.RMSE[index],
                              mae: predictionResults.MAE[index]
                            })
                          ).sort((a, b) => a.rmse - b.rmse);
                          return (
                            <Table
                              bgColor="white"
                              maxW="1200px"
                              borderColor="gray.800"
                              borderWidth={1}
                              variant="striped"
                            >
                              <Thead bgColor="teal.100">
                                <Tr>
                                  <Th>
                                    <Text fontSize={15}>Model</Text>
                                  </Th>
                                  <Th>
                                    <Text fontSize={15}>RMSE</Text>
                                  </Th>
                                  <Th>
                                    <Text fontSize={15}>MAE</Text>
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {sortedResults.map((result) => (
                                  <Tr key={result.model}>
                                    <Td>{result.model}</Td>
                                    <Td>{result.rmse.toFixed(4)}</Td>
                                    <Td>{result.mae.toFixed(4)}</Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          );
                        })()}
                      </Collapse>
                    </>
                  )
                )}
              </Flex>}
            </Flex>
          </Flex>

          {/* Recommended Model and Collapsible Sections */}
          <Flex
            align={"flex-start"}
            direction={"column"}
            mt={4}
            p={4}
            borderWidth="1px"
            borderRadius="md"
          >
            {predictionResults && predictionResults.Model && (
              <Text mt={2} color="teal.600" fontWeight="bold">
                คำแนะนำ: โมเดลที่แนะนำสำหรับ {selectedTarget} คือ{" "}
                <b>
                  {predictionResults.Model[
                    predictionResults.RMSE.indexOf(
                      Math.min(...predictionResults.RMSE)
                    )
                  ]}
                </b>{" "}
                เนื่องจากมีค่าความผิดพลาด RMSE ต่ำที่สุด
              </Text>
            )}

            {/* Toggle for RMSE/MAE Definitions */}
            <Button
              variant="link"
              onClick={() => setShowDefinitions(!showDefinitions)}
              mt={2}
            >
              {showDefinitions
                ? "คำอธิบาย RMSE และ MAE (คลิกเพื่อซ่อน)"
                : "แสดง: คำอธิบาย RMSE และ MAE (คลิกเพื่อแสดง)"}
            </Button>
            <Collapse in={showDefinitions}>
              <Box mt={2}>
                <Text fontWeight="bold" mb={1}>
                  RMSE (Root Mean Squared Error):
                </Text>
                <Text ml={2} mb={2}>
                  เป็นการวัดความคลาดเคลื่อนโดยการคำนวณรากที่สองของค่าเฉลี่ยของค่าความแตกต่างยกกำลังสองระหว่างค่าที่ทำนายกับค่าจริง
                  ยิ่งค่า RMSE สูง แสดงว่าโมเดลมีความผิดพลาดมากขึ้น
                </Text>
                <Text fontWeight="bold" mb={1}>
                  MAE (Mean Absolute Error):
                </Text>
                <Text ml={2}>
                  เป็นการวัดความคลาดเคลื่อนโดยการคำนวณค่าเฉลี่ยของความแตกต่างในรูปแบบสัมบูรณ์ระหว่างค่าที่ทำนายกับค่าจริง
                  ซึ่งให้ภาพรวมที่เข้าใจง่ายถึงระดับความผิดพลาดของโมเดล
                </Text>
              </Box>
            </Collapse>

            {(showModelDescription || showDefinitions) && <Divider mt={4} />}

            {/* Toggle for Model Descriptions */}
            <Button
              variant="link"
              onClick={() => setShowModelDescription(!showModelDescription)}
              mt={2}
            >
              {showModelDescription
                ? "คำอธิบาย Model (คลิกเพื่อซ่อน)"
                : "คำอธิบาย Model (คลิกเพื่อแสดง)"}
            </Button>
            <Collapse in={showModelDescription}>
              <Box mt={2}>
                <Text fontWeight="bold" mb={1}>
                  ARMA (Autoregressive Moving Average):
                </Text>
                <Text ml={2} mb={2}>
                  แบบจำลองทางสถิติที่ใช้ในการวิเคราะห์และพยากรณ์ข้อมูลอนุกรมเวลา โดยพิจารณาทั้งค่าในอดีตของข้อมูลเอง (Autoregressive) และค่าความคลาดเคลื่อนในอดีต (Moving Average)
                </Text>

                <Text fontWeight="bold" mb={1}>
                  ARIMA (Autoregressive Integrated Moving Average):
                </Text>
                <Text ml={2} mb={2}>
                  ส่วนขยายของ ARMA ที่เพิ่มขั้นตอนการทำให้ข้อมูลนิ่ง (Integration) เพื่อให้สามารถใช้กับข้อมูลอนุกรมเวลาที่ไม่นิ่งได้
                </Text>

                <Text fontWeight="bold" mb={1}>
                  ARIMAX (Autoregressive Integrated Moving Average with Exogenous Regressors):
                </Text>
                <Text ml={2} mb={2}>
                  ARIMA ที่เพิ่มตัวแปรภายนอก (Exogenous Regressors) เข้ามาในแบบจำลอง เพื่อพิจารณาอิทธิพลของตัวแปรอื่น ๆ ที่มีต่อข้อมูลอนุกรมเวลา
                </Text>

                <Text fontWeight="bold" mb={1}>
                  Random Forest:
                </Text>
                <Text ml={2} mb={2}>
                  อัลกอริทึมการเรียนรู้ของเครื่องแบบ decision tree ที่สร้าง tree หลายต้นและรวมผลลัพธ์เพื่อเพิ่มความแม่นยำในการทำนาย
                </Text>

                <Text fontWeight="bold" mb={1}>
                  Gradient Boosting:
                </Text>
                <Text ml={2} mb={2}>
                  อัลกอริทึมการเรียนรู้ของเครื่องที่สร้างแบบจำลองโดยการเพิ่ม decision tree ทีละต้น โดยแต่ละต้นจะพยายามแก้ไขข้อผิดพลาดของต้นก่อนหน้า
                </Text>

                <Text fontWeight="bold" mb={1}>
                  SVR (Support Vector Regression):
                </Text>
                <Text ml={2}>
                  อัลกอริทึมการเรียนรู้ของเครื่องที่ใช้หลักการของ Support Vector Machines (SVM) ในการทำนายค่าตัวแปรต่อเนื่อง โดยพยายามหาเส้นที่เหมาะสมที่สุดในการทำนายข้อมูล
                </Text>
              </Box>
            </Collapse>
          </Flex>
        </ModalBody>
        <ModalFooter>
          {!isPredictLoading && (
            <Button
              variant="outline"
              px={4}
              colorScheme="teal"
              onClick={onClose}
            >
              {predictionResults ? "ปิด" : "ยกเลิก"}
            </Button>
          )}
          {isPredictLoading && <Text>กำลังประมวลผล...</Text>}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TargetSelectionModal;
